/**
 * WARNING!
 * KEEP IN MIND THAT MOST ROUTE NAMES AND PATHS IN THE PROJECT ARE STILL USED AS STRING LITERALS.
 * CONSTANTS LISTED IN THE FILE WERE INTRODUCED LATER.
 * IT'S THE RECOMMENDED METHOD TO ADD NEW ROUTES.
 */

export const FLAG_NAMES = {
  // Indicates that the page is available without authorization
  IS_PUBLIC_PAGE: 'IS_PUBLIC_PAGE',
  // Indicates that the page a part of Sign-in and Sign-up flows
  USE_SIGN_IN_SIGN_UP_PAGE: 'USE_SIGN_IN_SIGN_UP_PAGE'
}

export const ROUTES = {
  HOME: {
    name: 'home',
    path: '/'
  },

  // Sing-in and Sign-up related routes
  SIGN_IN: {
    name: 'signin',
    path: '/signin',
    flags: {
      [FLAG_NAMES.USE_SIGN_IN_SIGN_UP_PAGE]: true
    }
  },
  SIGN_UP: {
    name: 'signup',
    path: '/signup',
    flags: {
      [FLAG_NAMES.USE_SIGN_IN_SIGN_UP_PAGE]: true
    }
  },
  PASSWORD_RESET: {
    name: 'password-reset',
    path: '/password-reset',
    flags: {
      [FLAG_NAMES.USE_SIGN_IN_SIGN_UP_PAGE]: true
    }
  },
  PASSWORD_UPDATE: {
    name: 'password-update',
    path: '/password-update',
    flags: {
      [FLAG_NAMES.USE_SIGN_IN_SIGN_UP_PAGE]: true
    }
  },
  CONFIRM_EMAIL: {
    name: 'confirm-email',
    path: '/confirm-email',
    flags: {
      [FLAG_NAMES.USE_SIGN_IN_SIGN_UP_PAGE]: true
    }
  },
  CONFIRMATION_LINK_EXPIRED: {
    name: 'confirmation-link-expired',
    path: '/confirmation-link-expired',
    flags: {
      [FLAG_NAMES.USE_SIGN_IN_SIGN_UP_PAGE]: true
    }
  },
  INVITATION_LINK_EXPIRED: {
    name: 'invitation-link-expired',
    path: '/invitation-link-expired',
    flags: {
      [FLAG_NAMES.USE_SIGN_IN_SIGN_UP_PAGE]: true
    }
  },
  COMPLETE_SIGN_UP: {
    name: 'complete-signup',
    path: '/complete-signup',
    flags: {
      [FLAG_NAMES.USE_SIGN_IN_SIGN_UP_PAGE]: true
    }
  },
  ADD_AGENCY: {
    name: 'add-agency',
    path: '/add-agency',
    flags: {
      [FLAG_NAMES.USE_SIGN_IN_SIGN_UP_PAGE]: true
    }
  },
  ADD_AGENCY_ATLASSIAN: {
    name: 'add-agency-atlassian',
    path: '/add-agency-atlassian',
    flags: {
      [FLAG_NAMES.USE_SIGN_IN_SIGN_UP_PAGE]: true
    }
  },
  INVITE_TEAMMATES: {
    name: 'invite-teammates',
    path: '/invite-teammates',
    flags: {
      [FLAG_NAMES.USE_SIGN_IN_SIGN_UP_PAGE]: true
    }
  },
  INVITE_TEAMMATES_ATLASSIAN: {
    name: 'invite-teammates-atlassian',
    path: '/invite-teammates-atlassian',
    flags: {
      [FLAG_NAMES.USE_SIGN_IN_SIGN_UP_PAGE]: true
    }
  },
  WELCOME: {
    name: 'welcome',
    path: '/welcome',
    flags: {
      [FLAG_NAMES.USE_SIGN_IN_SIGN_UP_PAGE]: true
    }
  },

  // Public pages
  AVAILABLE_PROFILES: {
    name: 'available-profiles',
    path: '/available-profiles',
    flags: {
      [FLAG_NAMES.IS_PUBLIC_PAGE]: true
    }
  },

  WILDCARD: {
    name: '*',
    path: '*'
  }
}
